import React from 'react';
import { connect } from 'react-redux';
import { fetchAdministrationGroupes } from 'store/administration/administrationActions';
import AdministrationGroupes from './AdministrationGroupes';
import withLoader from 'components/Shared/withLoader';

const AdministrationGroupesWithLoader = withLoader(AdministrationGroupes);

class AdministrationGroupesContainer extends React.Component {

    componentDidMount() {
        this.props.fetchAdministrationGroupes();
    }

    render() {
        const { isLoading, groupes } = this.props;

        return (
            <AdministrationGroupesWithLoader
                isLoading={isLoading}
                groupes={groupes}
            />
        );
    }
}

const mapStateToProps = state => ({
    isLoading: state.administration.groupes.isLoading,
    groupes: state.administration.groupes.items
});

const mapDispatchToProps = dispatch => ({
    fetchAdministrationGroupes: () => dispatch(fetchAdministrationGroupes())
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationGroupesContainer);